var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBeaconConnection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7444_396296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 5.25L10.5 12.75L6 16.5V1.5L10.5 5.25L1.5 12.75M15.1084 4.875C15.9436 6.03603 16.4355 7.46057 16.4355 9C16.4355 10.5394 15.9436 11.964 15.1084 13.125M12.75 6.64293C13.2161 7.31108 13.4894 8.12366 13.4894 9.00007C13.4894 9.87649 13.2161 10.6891 12.75 11.3572",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7444_396296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeaconConnection);
export default __webpack_public_path__ + "static/media/beaconConnection.e22ff527b2622a01b5c92c491dcc45d0.svg";
export { ForwardRef as ReactComponent };